import { resolveReleaseDocument, trimDocName } from "@/hooks/documentNames";

export interface DocumentUsageItem {
  identity: string;
  label: string;
  navigationPath: string;
}

export const getDocumentUsageItem = (documents: unknown, referenceOrName: string): DocumentUsageItem => {
  const document = resolveReleaseDocument(documents, referenceOrName);
  const label = trimDocName(document?.name ?? referenceOrName);

  return {
    identity: document?.reference ?? label,
    label,
    navigationPath: label,
  };
};
